// Eyelash KPI tile for the marketing dashboard. Delta arrow is teal up /
// rose down (semantic), value is navy, label is a small caps eyebrow.

import { Card } from '../ui';

export default function KpiTile({ label, value, lash = 'blue', delta = null, deltaDir = null, foot = null, loading = false }) {
  return (
    <Card lash={lash} className="px-3.5 py-3">
      <div className="text-[10.5px] font-black tracking-[0.04em] uppercase text-ink-2">{label}</div>
      <div className="text-[24px] font-black text-navy tracking-[-0.02em] mt-1 mb-0.5 tabular-nums">
        {loading ? <span className="text-ink-3">…</span> : value}
      </div>
      <div className="flex items-center justify-between mt-1.5 min-h-[16px]">
        {delta != null ? (
          <span className={`text-[12px] font-black inline-flex gap-1 ${
            deltaDir === 'up' ? 'text-deep-teal' : deltaDir === 'down' ? 'text-rose' : 'text-ink-3'
          }`}>
            {deltaDir === 'up' ? '▲' : deltaDir === 'down' ? '▼' : ''} {delta}
          </span>
        ) : <span />}
        {foot && <span className="text-ink-2 text-[11px]">{foot}</span>}
      </div>
    </Card>
  );
}
